"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventOnce = exports.useEvent = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const react_1 = require("react");
class EventBus extends eventemitter3_1.default {
    static instance;
    static get bus() {
        if (this.instance)
            return this.instance;
        this.instance = new EventBus();
        return this.instance;
    }
}
exports.default = EventBus;
const useEvent = (event, fn) => {
    (0, react_1.useEffect)(() => {
        EventBus.bus.on(event, fn);
        return () => {
            EventBus.bus.off(event, fn);
        };
    }, [event, fn]);
};
exports.useEvent = useEvent;
const useEventOnce = (event, fn) => {
    (0, react_1.useEffect)(() => {
        EventBus.bus.once(event, fn);
        return () => {
            EventBus.bus.off(event, fn);
        };
    }, [event, fn]);
};
exports.useEventOnce = useEventOnce;
